<template>
  <div>
    <div style="display: flex; align-items: center">
      <el-select
        v-model="classIndex"
        placeholder="请选择班级"
        @change="onChangeClass"
      >
        <el-option
          v-for="(item, index) in classList"
          :key="item.Id"
          :label="item.GradeNameAndClassName"
          :value="index"
        >
        </el-option>
      </el-select>
      <el-select v-model="cycleIndex" placeholder="请选择周期" class="m-left">
        <el-option
          v-for="(item, index) in cycleInfoData"
          :key="item.Id"
          :label="item.Name"
          :value="index"
        >
        </el-option>
      </el-select>
      <el-select v-model="domainIndex" placeholder="请选择领域" class="m-left">
        <el-option
          v-for="(item, index) in domainList"
          :key="item.CateId"
          :label="item.CateName"
          :value="index"
        >
        </el-option>
      </el-select>

      <el-select v-model="statusValue" placeholder="请选择状态" class="m-left">
        <el-option
          v-for="item in statusList"
          :key="item.Id"
          :label="item.Name"
          :value="item.Id"
        >
        </el-option>
      </el-select>
      <el-input
        placeholder="请输入幼儿姓名"
        v-model="searchName"
        class="input-with-select m-left"
      >
      </el-input>
      <el-button type="goon" class="m-left" @click="onClickSearch"
        >查询</el-button
      >
      <el-button
        type="goon"
        class="m-left"
        :disabled="tableData.length == 0"
        @click="onClickOpen"
        >导出</el-button
      >
      <el-button type="goon" class="m-left" @click="onEmpty">清空</el-button>
    </div>
    <!-- 评价表格 -->
    <el-row style="margin-top: 40px">
      <el-col>
        <!-- <el-card> -->
        <div class="flex-items" v-if="testInfo && testInfo.length != 0">
          <div class="flex-items" style="margin-right: 0.25rem">
            <i
              class="el-icon-success"
              style="font-size: 0.35rem; color: #67cd50"
            ></i>
            <div style="font-size: 0.2rem; margin-left: 0.0625rem">
              已评：{{ testInfo[0].value }}人
            </div>
          </div>
          <div class="flex-items">
            <i
              class="el-icon-warning"
              style="font-size: 0.35rem; color: #fb6e22"
            ></i>
            <div style="font-size: 0.2rem; margin-left: 0.0625rem">
              未评：{{ testInfo[1].value }}人
            </div>
          </div>
        </div>
        <el-table
          :data="tableData"
          style="width: 100%; margin-top: 0.25rem"
          border
          :header-cell-style="{ background: '#F2F5FF', color: '#333' }"
        >
          <el-table-column prop="StudyYearName" label="学届" align="center">
          </el-table-column>
          <el-table-column prop="StudentName" label="姓名" align="center">
          </el-table-column>
          <el-table-column prop="ClassName" label="班级" align="center">
          </el-table-column>
          <el-table-column label="领域" align="center">
            <template v-if="domainList.length != 0" slot-scope="scope">
              {{ domainList[domainIndex].CateName }}
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center">
            <template slot-scope="scope">
              <div :style="{ color: scope.row.IsTest == 0 ? '#999' : '#333' }">
                {{ scope.row.IsTest == 0 ? "未评价" : "已评价" }}
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- </el-card> -->
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {
  FrontGetQuestionCategoryNodes,
  GetTeacherClassRoleInfo,
  GetOpenCycleInfoSelectResult,
  GetParentIsTestInfo,
  GetParentTestStatusInfo,
} from "@/api/api.js";
import uploadUrl from "../../../api/api";

export default {
  data() {
    return {
      classList: [],
      classIndex: 0,
      cycleInfoData: [],
      cycleIndex: 0,
      domainList: [],
      domainIndex: 0,
      statusList: [
        {
          Name: "已评",
          Id: 1,
        },
        {
          Name: "未评",
          Id: 0,
        },
      ],
      statusValue: "",
      searchName: "",
      tableData: [],
      testInfo: [],
    };
  },
  async created() {
    this.userInfo = JSON.parse(window.localStorage.getItem("user"));

    await this.GetTeacherClassRoleInfo();
    await this.GetOpenCycleInfoSelectResult();
    await this.FrontGetQuestionCategoryNodes();
    await this.GetParentIsTestInfo();
    await this.GetParentTestStatusInfo();
  },
  methods: {
    async onClickOpen() {
      window.open(
        `${
          uploadUrl.uploadUrl
        }/api/mgd/EvalTerm/Export_GetParentTestStatusInfo?CycleId=${
          this.cycleInfoData[this.cycleIndex].Id
        }&ClassId=${this.classList[this.classIndex].Id}&CateId=${
          this.domainList[this.domainIndex].CateId
        }&Status=${
          this.statusValue == "" ? -1 : this.statusValue
        }&StudyYearId=${this.classList[this.classIndex].StudyYearId}&GradeId=${
          this.classList[this.classIndex].GradeId
        }&UserId=${this.userInfo.uID}`,
        "_brank"
      );
    },
    onChangeClass() {
      //console.log(123);
      this.GetOpenCycleInfoSelectResult();
    },
    onEmpty() {
      this.statusValue = "";
      this.searchName = "";
      this.GetParentIsTestInfo();
      this.GetParentTestStatusInfo();
    },
    //   学期评价表格
    async GetParentTestStatusInfo() {
      let res = await GetParentTestStatusInfo({
        StudyYearId: this.classList[this.classIndex].StudyYearId,
        CycleId: this.cycleInfoData[this.cycleIndex].Id,
        GradeId: this.classList[this.classIndex].GradeId,
        ClassId: this.classList[this.classIndex].Id,
        CateId: this.domainList[this.domainIndex].CateId,
        Status: this.statusValue == "" ? -1 : this.statusValue,
        PageSize: 500,
        PageIndex: 1,
      });
      if (res.data.success) {
        this.tableData = res.data.response.data;
      } else {
        this.tableData = [];
      }
    },
    // 学期评价数量
    async GetParentIsTestInfo() {
      let res = await GetParentIsTestInfo({
        StudyYearId: this.classList[this.classIndex].StudyYearId,
        CycleId: this.cycleInfoData[this.cycleIndex].Id,
        GradeId: this.classList[this.classIndex].GradeId,
        ClassId: this.classList[this.classIndex].Id,
        CateId: this.domainList[this.domainIndex].CateId,
        Status: this.statusValue == "" ? -1 : this.statusValue,
      });
      if (res.data.success) {
        this.testInfo = res.data.response;
      }
    },
    // 查询
    onClickSearch() {
      this.GetParentIsTestInfo();
      this.GetParentTestStatusInfo();
    },
    //   选择领域
    async FrontGetQuestionCategoryNodes() {
      let res = await FrontGetQuestionCategoryNodes({
        IsBaby: this.cycleInfoData[this.cycleIndex].IsBaby,
        BabyLevel: this.cycleInfoData[this.cycleIndex].BabyLevel,
      });
      if (res.data.success) {
        this.domainList = res.data.response;
      }
    },
    async GetOpenCycleInfoSelectResult() {
      let res = await GetOpenCycleInfoSelectResult({
        SchoolId: this.userInfo.SchoolId,
        StudyYearsId: this.classList[this.classIndex].StudyYearId,
      });
      if (res.data.success) {
        this.cycleInfoData = res.data.response;
      }
    },
    // 获取幼儿下拉数据
    async GetTeacherClassRoleInfo() {
      let xhr = await GetTeacherClassRoleInfo();
      let themeArr = [];
      let classArr = [];
      // if (this.userInfo.UserIdentity == "1") {
      //   classArr.push({
      //     GradeNameAndClassName: "全园",
      //     ClassName: "全园",
      //     GradeName: "全园",
      //     Id: 0,
      //   });
      // }
      xhr.data.response.forEach((Gradeitem) => {
        Gradeitem.ClassInfo.forEach((classItem) => {
          classArr.push({
            GradeNameAndClassName:
              Gradeitem.GradeName + (classItem.Name ? classItem.Name : ""),
            ClassName: classItem.Name ? classItem.Name : "",
            Id: classItem.Id,
            ...Gradeitem,
          });
        });
      });
      this.classList = classArr;
      //console.log(this.classList);
    },
    onClick(e) {},
  },
};
</script>
<style lang="less" scoped>
.m-left {
  margin-left: 20px;
}
.input-with-select {
  width: 300px;
}
.el-button--goon {
  color: #fff;
  background-color: #5474e6;
  border-color: #5474e6;
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
}
</style>